<template>
  <div class="user-devices">
    <el-button type="danger" size="mini" @click="$emit('on-clear')">
      <i class="fa fa-eraser"></i> Clear
    </el-button>
    <el-table :data="devices" border>
      <el-table-column label="User Devices">
        <el-table-column label="name" prop="device_name"></el-table-column>
        <el-table-column label="id" prop="device_id"></el-table-column>
        <el-table-column label="push" prop="push_enabled" align="center">
          <template slot-scope="scope">
            <check-icon :checked="scope.row.push_enabled"></check-icon>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<style scoped>
  .user-devices {
    position: relative;
  }
  button {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 1;
  }
</style>


<script>
import CheckIcon from '@/components/shared/CheckIcon'

export default {
  components: {
    CheckIcon
  },

  props: ['devices']
}
</script>



// WEBPACK FOOTER //
// src/components/users/UserDevices.vue